import React, { useEffect, useState } from "react";
import ProductForm from "../components/Products/ProductForm";
import { createProducts, getParticularProducts, updateProducts } from "../api/productAPI";
import { useParams, useNavigate } from "react-router-dom";

// Example of create handler with navigation
const handleCreate = async (productData, navigate) => {
  try {
    const response = await createProducts(productData);
    console.log("Product created:", response.data);
    navigate(-1); // Navigate back to the previous page
  } catch (error) {
    console.error("Error creating product:", error);
  }
};

// Example of update handler with navigation
const handleUpdate = async (productData, productId, navigate) => {
  try {
    const response = await updateProducts(productData, productId);
    console.log("Product updated:", response.data);
    navigate(-1); // Navigate back to the previous page
  } catch (error) {
    console.error("Error updating product:", error);
  }
};

const CreateProductPage = () => {
  const navigate = useNavigate(); // Initialize navigate

  return <ProductForm onSubmit={(data) => handleCreate(data, navigate)} />;
};

const UpdateProductPage = () => {
  const { id } = useParams();
  const [product, setProduct] = useState(null);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate(); // Initialize navigate

  // Fetch the product details when the component mounts
  useEffect(() => {
    const fetchProduct = async () => {
      try {
        const response = await getParticularProducts(id); // Call the API to get the product by ID
        setProduct(response); // Set the product data to state
        setLoading(false); // Disable loading once the data is fetched
      } catch (error) {
        console.error("Error fetching product:", error);
        setLoading(false); // Disable loading even if there's an error
      }
    };

    fetchProduct(); // Fetch the product
  }, [id]); // Only re-run the effect when the `id` changes

  if (loading) return <div>Loading...</div>; // Show loading state while fetching product

  return (
    <>
      <ProductForm
        onSubmit={(data) => handleUpdate(data, id, navigate)}
        productData={product}
      />
    </>
  );
};

export { CreateProductPage, UpdateProductPage };